import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "styled-components/macro";
import styled from "styled-components/macro";
import success from "../../assets/images/check.png";
import { FullScreenLoader } from "../../components";
import * as mq from "../../styles/mediaQueries";
import {
  LabelText,
  ShowText,
  SuccessImage,
} from "../ThankYou/ThankYouPage.style";
import {
  useGetApplicationNumberQuery,
  useGetCartQuery,
} from "../riders/services/rider";
import Footer from "../../components/Footer";
function JourneyComplete() {
  const appData = useGetApplicationNumberQuery();
  const appNo = appData?.data?.data?.proposal_reference_id;
  const { isLoading, data } = useGetCartQuery();
  const {
    frontendData: { tenant },
  } = useSelector(state => state.frontendBoot);
  if (isLoading) return <FullScreenLoader />;
  return (
    <div>
      <div
        className="container"
        css={`
          margin-top: 35px;
        `}
      >
        <Section className="col-md-12">
          <div className="container">
            <SuccessImage src={success} />
            <div className="col-md-12">
              <ShowText>Thank you for choosing {tenant.name}</ShowText>
            </div>
            <div className="col-md-12">
              <LabelText>
                Your documents has been submitted successfully and application
                no. is {appNo}. <br />
                {data?.product?.company?.name} will review your documents and we
                will get back to you shortly
              </LabelText>
            </div>
          </div>
          <div
            css={`
              text-align: center;
              margin-top: 20px;
            `}
          >
            <GoBackLink to="/">Back To Quotes</GoBackLink>
          </div>
        </Section>
      </div>
      <Footer />
    </div>
  );
}

export default JourneyComplete;

// const StyledLogo = styled(Logo)`
//   position: absolute;
//   top: 1em;
//   left: 6em;
// `;
// const Page = styled.div`
//   min-height: 100vh;
//   background: url(${SuccessBackground}) no-repeat center;
//   background-size: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

// const Subtitle = styled.p`
//   font-size: 1.1rem;
//   line-height: 1.6;
//   color: rgba(62, 62, 62, 0.55);
//   margin: 2em 0 3em;
// `;
const Section = styled.div`
  box-shadow: 0px -3px 20px rgb(134 156 213 / 25%);
  padding: 12px 60px;
  width: 57%;
  margin: 0 auto;
  margin-bottom: 24px;
  ${mq.sm} {
    width: 100%;
    padding: 12px 10px;
  }
`;

// const StatusWrap = styled.div`
//   text-align: center;
// `;

const GoBackLink = styled(Link)`
  border: 1px solid var(--primary-color);
  color: #fff;
  background-color: var(--primary-color);
  box-shadow: none;
  border-radius: 6px;
  min-width: 145px;
  line-height: 34px;
  text-align: center;
  border-style: solid;
  border-width: 1px;
  padding: 0 6px;
  font-size: 14px;
  display: inline-block;
  text-decoration: none;
  &:hover {
    color: #fff;
  }
`;
